<template>
  <a-divider />

  <a-row>
    <a-col
      class="subtask-label"
      @click.stop="checkIfEditable && showForm(FORM_NAME_TASK_EDIT)"
    >
      Подзадача {{ task.number }} {{ task.name }}
      <span class="edit-button" v-if="checkIfEditable">
        <img
          src="@/assets/icons/edit.svg"
          @click.stop="checkIfEditable && showForm(FORM_NAME_TASK_EDIT)"
          alt=""
        />
      </span>
    </a-col>
  </a-row>
  <div class="subtask-checkpoints">
    <check-points
      :task-id="task.id"
      :checkpoints="task.checkpoints"
      :disabled="!checkIfEditable"
      @update="updatedTasks"
    ></check-points>
  </div>

  <div class="subtask-executor">
    <div class="subtask-executor__name">
      Исполнитель:
      <span class="subtask-executor__fullname">{{ task.executor }} </span>
    </div>
    <div class="subtask-executor__progress">
      <progress-bar :items="task.checkpoints" incompleteColor="white" />
    </div>
  </div>

  <drawer-right v-model="isShowingDrawer" @close="onDrawerClose">
    <template v-if="FORM_NAME_TASK_EDIT === formName">
      <task-form
        :task="task"
        @updated="updatedTasks"
        @delete-action="showForm(FORM_NAME_TASK_DELETE)"
      />
    </template>
    <template v-else>
      <delete-task
        :task="task"
        @deleted="updatedTasks"
      />
    </template>
  </drawer-right>
</template>

<script setup>
  import { computed, ref, watch } from 'vue';
  import CheckPoints from '@/components/projects/management/CheckPoints/CheckPoints';
  import ProgressBar from '@/components/projects/management/ProgressBar.vue';
  import DeleteTask from '@/components/projects/management/Task/DeleteTask';
  import { FORM_NAME_TASK_DELETE, FORM_NAME_TASK_EDIT } from '../Task/constants/form-name';
  import TaskForm from '../Task/TaskForm.vue';
  import DrawerRight from '@/components/drawers/components/DrawerRight.vue';

  const props = defineProps({
    task: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    editorUserId: Number,
  });

  const emit = defineEmits(['updated']);

  const isShowingDrawer = ref(false);
  const formName = ref(null);

  watch(formName, () => {
    isShowingDrawer.value = null !== formName.value;
  });

  const onDrawerClose = () => {
    formName.value = null;
  };

  const showForm = (name) => {
    formName.value = name;
  };

  const updatedTasks = () => {
    formName.value = null;
    emit('updated');
  };
  
  const checkIfEditable = computed(() => {
    return (
      !props.disabled &&
      (props.editorUserId ? props.editorUserId === props.task.userId : true)
    );
  });
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .subtask-label {
    color: $color-bg-status-new;
    cursor: pointer;
    font: 700 16px/22px 'Nunito Sans';

    &:hover {
      .edit-button {
        visibility: visible;
        opacity: 1;
      }
    }

    .edit-button {
      bottom: 10px;
      visibility: hidden;
      opacity: 0;
      margin-left: 10px;
      position: absolute;
      transition: all 0.25s ease-in-out;
    }
  }

  .subtask-checkpoints {
    margin-top: 20px;
    margin-left: 20px;
  }

  .subtask-executor,
  .subtask-executor__fullname {
    color: #718096;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  .subtask-executor {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;

    &__fullname {
      font-weight: 400;
      margin-left: 10px;
    }
  }

  .ant-divider {
    border-color: #ffffff;
  }
</style>
